import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

import * as moment from 'moment';

import {DataTableConfigInterface} from './interfaces/data-table-config.interface';

@Component({
    selector: 'app-data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnInit {
    private actionMenuTrigger: MatMenuTrigger;

    @Input() public config: DataTableConfigInterface;

    @Output() public actionMenuLinkClicked: EventEmitter<[number, any]>;
    @Output() public rowClicked: EventEmitter<any>;

    @ViewChild('menuTriggerI', {static: true}) public menuTriggerI: ElementRef;

    public moreColumnKey: string;
    public notFoundColumnKey: string;

    constructor() {
    }

    ngOnInit() {
        this.actionMenuLinkClicked = new EventEmitter();
        this.rowClicked = new EventEmitter();
        this.moreColumnKey = 'more_' + moment().toString();
        this.notFoundColumnKey = 'not_found_' + moment().toString();

        if (!this.config) {
            this.config = {
                dataSource: [],
                dataSourceKeys: [],
                actionMenu: false,
                actionMenuLinks: []
            };
        }
    }

    getColumnKeys(): string[] {
        const keys = this.config.dataSourceKeys.map((tuple: [string, string]) => {
            return tuple[0];
        });

        if (this.config.actionMenu) {
            keys.push(this.moreColumnKey);
        }

        return keys;
    }

    actionMenuTriggered(menuTrigger: MatMenuTrigger) {
        this.actionMenuTrigger = menuTrigger;
    }

    onActionMenuOutsideClick(element) {
        if (
            this.actionMenuTrigger &&
            (this.menuTriggerI.nativeElement.outerHTML !== element.outerHTML)
        ) {
            this.actionMenuTrigger.closeMenu();
        }
    }

    onActionMenuLinkClicked(action: number) {
        this.actionMenuLinkClicked.emit([action, this.actionMenuTrigger.menuData]);
    }

    onRowClicked(row) {
        this.rowClicked.emit(row);
    }
}
